<template>
  <circle
    v-if="count > 0"
    :cx="cx"
    :cy="cy"
    :r="radius"
    fill="rgba(204, 0, 0, 0.5)"
    class="bubble-circle"
    v-on="$listeners"
  />
</template>

<script>
const FALLBACK_CIRCLE_SCALE = 1000;

export default {
  name: 'BubbleCircle',
  props: {
    cx: {
      type: Number,
      required: true,
    },
    cy: {
      type: Number,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    minRadius: {
      type: Number,
      required: true,
    },
    maxRadius: {
      type: Number,
      required: true,
    },
    circleScaleMax: {
      type: Number,
      default: FALLBACK_CIRCLE_SCALE,
    },
  },
  computed: {
    radius() {
      if (this.count === 0) return this.minRadius;
      const radiusRange = this.maxRadius - this.minRadius;
      const scaleFactor = radiusRange / Math.log10(this.circleScaleMax + 1);
      const radius = this.minRadius + Math.log10(this.count + 1) * scaleFactor;
      return Math.min(radius, this.maxRadius);
    },
  },
};
</script>

<style scoped>
.bubble-circle {
  cursor: crosshair;
  transition: fill 0.15s;
}

.bubble-circle:hover {
  fill: rgba(204, 0, 0, 0.8);
}
</style>
